class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.loading = false;
	}

	connectedCallback(){
		const drawer = this.closest('#site-cart-sidebar');
		if (!drawer || drawer.opened || drawer.classList.contains('sidebar--opened')) {
			this.generateRecommendations();
		}
	}

	generateRecommendations(){
		if (this.loading || this.dataset.loaded === 'true') return;

		const cartForm = document.getElementById('AjaxCartForm');
		if (!cartForm) return;

		const cartItems = cartForm.querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			const cartItem = Array.from(cartItems).find(product => product.getAttribute('data-price') != '0');
			if (!cartItem?.dataset?.productId) return;

			this.loading = true;
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItem.dataset.productId}&limit=${this.dataset.limit}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
          	this.innerHTML = innerHTML.innerHTML;
          }
					this.dataset.loaded = 'true';
				}).then(()=>{
					if (typeof cartSliderFormSubmit === 'function') cartSliderFormSubmit("#cart-recommendations form.upsell", false);
					if (typeof cartSliderSelect === 'function') cartSliderSelect("#cart-recommendations form.upsell select");
					if (window.swat) window.swat.initializeActionButtons('body')
				})
				.catch(error => console.warn('Cart recommendations unavailable.', error))
				.finally(() => { this.loading = false; });
		}
	}
}
if (!customElements.get('cart-recommendations')) {
	customElements.define('cart-recommendations', CartRecommendations);
}
